import { useEffect, useState } from "react";
import DriverShell from "../components/DriverShell";
import { authenticatedApi, authenticatedUpload } from "../lib/api";
import { getDriverSession } from "../lib/driverSession";

export default function DriverCommissionsPage() {
  const driver = getDriverSession();
  const [account, setAccount] = useState(null);
  const [form, setForm] = useState({ amount: "", method: "YAPE", reference: "", proof: null });
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function load() {
    if (!driver?.auth_token) return;
    try {
      const response = await authenticatedApi("/delivery/commission-account", driver.auth_token, { method: "POST", body: "{}" });
      setAccount(response.account);
      setError("");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, [driver?.auth_token]);

  async function reportPayment(event) {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    setError("");
    try {
      const payload = new FormData();
      payload.append("amount", form.amount);
      payload.append("method", form.method);
      payload.append("reference", form.reference);
      if (form.proof) payload.append("proof_image", form.proof);
      const response = await authenticatedUpload("/delivery/commission-payment", driver.auth_token, payload);
      setMessage(response.message);
      setForm({ amount: "", method: "YAPE", reference: "", proof: null });
      await load();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <DriverShell>
      <div className="driver-page-heading"><small>CUENTA DEL MOTORIZADO</small><h1>Comisiones</h1></div>
      {loading && <div className="food-message"><b>Cargando cuenta…</b></div>}
      {error && <div className="food-message food-message--error"><b>{error}</b></div>}
      {message && <div className="wallet-message">{message}</div>}
      {account && (
        <>
          <section className="driver-commission-metrics">
            <article><small>GANANCIA NETA DEL MES</small><strong>S/ {Number(account.earnings_month_net || 0).toFixed(2)}</strong><span>Bruto S/ {Number(account.earnings_month_gross || 0).toFixed(2)}</span></article>
            <article className={account.blocked ? "is-danger" : ""}><small>COMISIÓN PENDIENTE</small><strong>S/ {Number(account.balance || 0).toFixed(2)}</strong><span>Límite S/ {Number(account.limit || 0).toFixed(2)}</span></article>
          </section>
          <div className="driver-commission-progress"><span style={{ width: `${account.usage_percent || 0}%` }} /></div>
          {Number(account.balance) > 0 && (
            <form className="driver-payment-form" onSubmit={reportPayment}>
              <h2>Registrar pago de comisión</h2>
              <p>El administrador revisará el comprobante antes de descontar el saldo.</p>
              <div>
                <label>Monto<input type="number" min="0.01" max={account.balance} step="0.01" value={form.amount} onChange={(event) => setForm({ ...form, amount: event.target.value })} required /></label>
                <label>Método<select value={form.method} onChange={(event) => setForm({ ...form, method: event.target.value })}><option>YAPE</option><option>PLIN</option><option>BANK</option><option>CASH</option></select></label>
              </div>
              <label>Operación o referencia<input value={form.reference} onChange={(event) => setForm({ ...form, reference: event.target.value })} /></label>
              <label>Captura del pago<input type="file" accept="image/*" onChange={(event) => setForm({ ...form, proof: event.target.files?.[0] || null })} /></label>
              <button disabled={busy} type="submit">{busy ? "Enviando…" : "Enviar para revisión"}</button>
            </form>
          )}
          <section className="driver-movements">
            <h2>Últimos movimientos</h2>
            {account.movements?.map((movement) => <article key={movement.id}><div><b>{movement.description}</b><small>{movement.created_at}</small></div><strong className={Number(movement.amount) < 0 ? "is-payment" : ""}>S/ {Number(movement.amount || 0).toFixed(2)}</strong></article>)}
          </section>
        </>
      )}
    </DriverShell>
  );
}
